import { SscAvatarTheme } from '@marineform/ssc-ui';

export type AppearanceAmbience =
  | 'fresh'
  | 'turbo'
  | 'velocity'
  | 'electric'
  | 'carbon'
  | 'nitro';

export type AppearanceAmbienceOption = {
  avatarTheme: SscAvatarTheme;
  gradientClasses: string;
  id: AppearanceAmbience;
  labelKey: string;
};

export const APPEARANCE_AMBIENCE_OPTIONS = [
  {
    id: 'fresh',
    labelKey: 'manage|appearance|ambience|fresh',
    gradientClasses:
      'bg-gradient-to-r from-emerald-500 via-lime-500 to-green-500',
    avatarTheme: 'green',
  },
  {
    id: 'turbo',
    labelKey: 'manage|appearance|ambience|turbo',
    gradientClasses:
      'bg-gradient-to-r from-amber-500 via-yellow-500 to-orange-500',
    avatarTheme: 'amber',
  },
  {
    id: 'velocity',
    labelKey: 'manage|appearance|ambience|velocity',
    gradientClasses: 'bg-gradient-to-r from-red-600 via-red-500 to-rose-500',
    avatarTheme: 'red',
  },
  {
    id: 'electric',
    labelKey: 'manage|appearance|ambience|electric',
    gradientClasses: 'bg-gradient-to-r from-blue-600 via-sky-500 to-cyan-500',
    avatarTheme: 'blue',
  },
  {
    id: 'carbon',
    labelKey: 'manage|appearance|ambience|carbon',
    gradientClasses:
      'bg-gradient-to-r from-neutral-500 via-stone-500 to-stone-600',
    avatarTheme: 'stone',
  },
  {
    id: 'nitro',
    labelKey: 'manage|appearance|ambience|nitro',
    gradientClasses:
      'bg-gradient-to-r from-purple-600 via-fuchsia-500 to-violet-500',
    avatarTheme: 'purple',
  },
] as const satisfies readonly AppearanceAmbienceOption[];

export const AMBIENCES: readonly AppearanceAmbience[] =
  APPEARANCE_AMBIENCE_OPTIONS.map((option) => option.id);

export const AMBIENCE_GRADIENT_CLASSES: Record<AppearanceAmbience, string> =
  Object.fromEntries(
    APPEARANCE_AMBIENCE_OPTIONS.map((option) => [
      option.id,
      option.gradientClasses,
    ]),
  ) as Record<AppearanceAmbience, string>;

export const AMBIENCE_AVATAR_THEMES: Record<AppearanceAmbience, SscAvatarTheme> =
  Object.fromEntries(
    APPEARANCE_AMBIENCE_OPTIONS.map((option) => [
      option.id,
      option.avatarTheme,
    ]),
  ) as Record<AppearanceAmbience, SscAvatarTheme>;
